import { useState } from "react";
import { useMutation } from "@apollo/client/react";
import { ADD_USER_BY_ADMIN } from "@/hooks";

interface AddUserAdminResponse {
  createUserAdmin?: {
    success: boolean;
    message?: string;
  };
  comCreateUserAdmin?: {
    success: boolean;
    message?: string;
  };
}

interface UseAddUserByAdminReturn {
  addUserByAdmin: any;
  loading: boolean;
  success: boolean;
  data: any;
  resetForm: boolean;
}

export const useAddUserByAdmin = (
  onCompleted?: () => void,
  onError?: (_error: string) => void,
): UseAddUserByAdminReturn => {
  const [success, setSuccess] = useState(false);
  const [resetForm, setResetForm] = useState(false);

  const _onCompleted = onCompleted || (() => {});
  const _onError = onError || (() => {});

  const [addUserByAdmin, { loading, data }] = useMutation<AddUserAdminResponse>(
    ADD_USER_BY_ADMIN,
    {
      onCompleted: (response) => {
        const res = response.createUserAdmin || response.comCreateUserAdmin;
        if (res?.success) {
          setSuccess(true);
          setResetForm(true);
          setTimeout(() => {
            setSuccess(false);
            setResetForm(false);
          }, 5000);
          _onCompleted();
        } else {
          setSuccess(false);
        }
      },
      onError: ({ message: _message }) => {
        setSuccess(false);
        _onError(_message);
      },
    },
  );

  return {
    addUserByAdmin,
    loading,
    success,
    data,
    resetForm,
  };
};
